import { ImpersonateService } from 'data/services';
import { ImpersonateServiceInterface } from 'domain/services';
import { makeRemoteImpersonatePerson } from 'main/factories/usecases/impersonate/impersonate-person.factory';

export const makeImpersonateService = (): ImpersonateServiceInterface => {
  return new ImpersonateService({
    impersonatePerson: makeRemoteImpersonatePerson(),
  });
};
